import { render, staticRenderFns } from "./PatientSurgeryReport.vue?vue&type=template&id=17d089b2"
import script from "./PatientSurgeryReport.vue?vue&type=script&lang=js"
export * from "./PatientSurgeryReport.vue?vue&type=script&lang=js"
import style0 from "./PatientSurgeryReport.vue?vue&type=style&index=0&id=17d089b2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports